import { RouterProvider } from 'react-router-dom';
import { CustomerAuthInitializer } from '@/components/customer-portal/CustomerAuthInitializer';
import { Providers } from '@/providers';
import { CustomerThemeProvider } from '@/providers/CustomerThemeProvider';
import { customerPortalRouter } from '@/routes/customer-portal-router';
import { CustomerBrandingEffect } from '@/layouts/customer-portal/CustomerBrandingEffect';

export function CustomerPortalApp() {
  return (
    <Providers>
      <CustomerThemeProvider>
        {/* Outside the auth boundary so it survives login/logout and can reset
            the title and favicon when the customer session ends. */}
        <CustomerBrandingEffect />
        <CustomerAuthInitializer>
          <RouterProvider router={customerPortalRouter} />
        </CustomerAuthInitializer>
      </CustomerThemeProvider>
    </Providers>
  );
}
